import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_494256c3f529d480d29e5d557f8f50cf/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { API_PROXY_PREFIX } from 'portal-common/constants';
import { NAMESPACE } from 'portal-common/constants/requestConstants';
import { api } from 'portal-common/http';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
export var queryAccountType = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(uin, skey) {
        var API_PREFIX, res;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    API_PREFIX = "".concat(API_PROXY_PREFIX, "/").concat(NAMESPACE.CHANNEL_API, "/backend-partner-account");
                    _ctx.next = 3;
                    return api.call("".concat(API_PREFIX, "/QueryAccountType"), {
                        method: 'post',
                        body: {
                            auth: {
                                uin: uin,
                                skey: skey
                            }
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    if (!(res.code === 200)) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 6:
                    return _ctx.abrupt("return", res);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function queryAccountType(uin, skey) {
        return _ref.apply(this, arguments);
    };
}();
